var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{class:`avatarStatus avatarStatus--${_vm.stateUser}`,style:(`width: ${_vm.containerWidth}px; height: ${_vm.containerHeight}px`)},[_c('Avatar',{staticClass:"avatarStatus__avatar",attrs:{"user":_vm.user}}),_c('span',{class:`avatarStatus__statusCircle avatarStatus__statusCircle--${_vm.stateUser}`})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }